import { cn } from "@/lib/utils";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
};

export function TypographyInlineCode({ children, className, ...props }: Props) {
  return (
    <code
      {...props}
      className={cn(
        "relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-xs font-semibold",
        className
      )}
    >
      {children}
    </code>
  );
}
